import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Grow from "@material-ui/core/Grow";
import IconButton from "@material-ui/core/IconButton";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import Paper from "@material-ui/core/Paper";
import Popper from "@material-ui/core/Popper";
import { makeStyles } from "@material-ui/core/styles";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { useState } from "react";

const useDropdownArrowWithPopoverStyles = makeStyles(
  (theme) => ({
    buttonToggle: {
      "&, &:focus": {
        outline: "none"
      }
    },
    icon: {
      marginRight: theme.spacing(1),
      width: theme.spacing(2),
      height: theme.spacing(2)
    }
  }),
  { meta: "removeForExport" }
);

/**
 * Supports the following props
 *   idSuffix  - string to append to id
 *   menuItems - array of objects, each containing: [1] onCLick; [2] children
 *             - Example: [{ onClick: () => {}, children: 'Re-generate PDF' }]
 */
export default function DropdownArrowWithPopover(props) {
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = (event) => {
    const target = event.currentTarget;
    setTimeout(() => {
      setAnchorEl(anchorEl ? null : target);
    });
  };
  const open = Boolean(anchorEl);

  const handleClose = (event) => {
    setAnchorEl(null);
  };

  const { idSuffix = "", menuItems = [] } = props;

  const idSuffixStr = idSuffix ? `-${idSuffix}` : "";
  const menuId = `collapsible-menu${idSuffixStr}`;
  const ExpandIcon = !open ? ExpandLessIcon : ExpandMoreIcon;
  const classes = useDropdownArrowWithPopoverStyles();
  return (
    <>
      <IconButton
        className={classes.buttonToggle}
        size="small"
        color="secondary"
        disableRipple={true}
        disableFocusRipple={true}
        aria-controls={open ? menuId : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <ExpandIcon />
      </IconButton>
      <Popper
        open={open}
        anchorEl={anchorEl}
        role={undefined}
        transition
        disablePortal
        placement="top-start"
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === "bottom" ? "left top" : "left bottom"
            }}
          >
            <Paper>
              <ClickAwayListener
                onClickAway={() => {
                  setAnchorEl(null);
                }}
              >
                <MenuList autoFocusItem={open} id={menuId}>
                  {menuItems.map(
                    ({ onClick, content, Icon, iconProps }, itemIdx) => {
                      const { className } = iconProps;
                      const allIconProps = {
                        ...iconProps,
                        className: !className
                          ? classes.icon
                          : `${className} ${classes.icon}`
                      };

                      return (
                        <MenuItem
                          key={itemIdx}
                          onClick={(e) => {
                            handleClose(e);
                            onClick(e);
                          }}
                        >
                          {Icon && <Icon {...allIconProps} />}
                          {content}
                        </MenuItem>
                      );
                    }
                  )}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
}
